import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";

import "./Css/View.css";
import profile from "./Images/Ellipse 24 (10).png";
import API_BASE from "../config/api";

const TeacherEdit = () => {
  const navigate = useNavigate();
  const { teacherUserId } = useParams();
  const token = localStorage.getItem("token");
  const [previewImage, setPreviewImage] = useState(null);
  const [softwares, setSoftwares] = useState([]);
  const [standards, setStandards] = useState([]);
  const [subjects, setSubjects] = useState([]);

  const [showPasswordPopup, setShowPasswordPopup] = useState(false);
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const [form, setForm] = useState({
    teacherName: "",
    email: "",
    phoneNumber: "",
    softwareIds: [],
    standardIds: [],
    subjectIds: [],
    profilePicture: null,
    isActive: true,
  });

  /* ================= DROPDOWNS ================= */
  useEffect(() => {
    if (!token) return;

    axios
      .get(`${API_BASE}/api/institute/teachers/dropdowns`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setSoftwares(res.data.softwares || []);
        setStandards(res.data.standards || []);
        setSubjects(res.data.subjects || []);
      });
  }, [token]);

  /* ================= TEACHER DATA ================= */
  useEffect(() => {
    if (teacherUserId) loadTeacher();
  }, [teacherUserId]);

 const loadTeacher = async () => {
  const res = await axios.get(
    `${API_BASE}/api/institute/teachers/${teacherUserId}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );

  setForm({
    teacherName: res.data.teacherName,
    email: res.data.email,
    phoneNumber: res.data.phoneNumber,
    softwareIds: res.data.softwareIds || [],
    standardIds: res.data.standardIds || [],
    subjectIds: res.data.subjectIds || [],
    profilePicture: null,
    isActive: res.data.isActive,
  });

  const API_BASE = `${API_BASE}`;

  setPreviewImage(
    res.data.profilePictureUrl
      ? `${API_BASE}${res.data.profilePictureUrl}`
      : null
  );
};

  const formatDate = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString("en-GB"); // dd/mm/yyyy
  };


  /* ================= HANDLERS ================= */
  const handleSelectArray = (e, key) => {
    const value = Number(e.target.value);
    if (!value) return;

    setForm((prev) => ({
      ...prev,
      [key]: [value],
    }));
  };


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setForm({ ...form, profilePicture: file });
    setPreviewImage(URL.createObjectURL(file));
  };

  /* ================= SAVE ================= */
  const handleSave = async () => {
    const fd = new FormData();

    fd.append("TeacherName", form.teacherName);
    fd.append("PhoneNumber", form.phoneNumber);
    fd.append("IsActive", form.isActive);

    form.softwareIds.forEach((id) => fd.append("SoftwareIds", id));
    form.standardIds.forEach((id) => fd.append("StandardIds", id));
    form.subjectIds.forEach((id) => fd.append("SubjectIds", id));

    if (form.profilePicture) {
      fd.append("ProfilePicture", form.profilePicture);
    }

    await axios.put(
      `${API_BASE}/api/institute/teachers/${teacherUserId}`,
      fd,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    navigate("/dashboard/techermanagment");
  };


  return (
    <div className="student-page">
      {/* Header */}
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          शिक्षक व्यवस्थापन  &gt;&gt; <span>संपादन करा</span>
        </h3>

        <div className="edit-btnn">
          <h5
            className="reset-link"
            onClick={() => setShowPasswordPopup(true)}
          >
            पासवर्ड रीसेट करा
          </h5>
          <button className="btn outlinee" onClick={() => navigate(-1)}>
            रद्द करा
          </button>
          <button className="btn primaryy" onClick={handleSave}>
            सेव्ह करा
          </button>

        </div>
      </div>

      <h2>शिक्षक प्रोफाइल संपादन करा </h2>

      <div className="profile-card">
        <div className="profile-img-wrapper">
          <img
            src={previewImage || profile}
            alt="teacher"
            className="profile-img"
          />


          {/* Edit Icon */}
          <label className="edit-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 18 18" fill="none">
              <path d="M2 16H3.425L13.2 6.225L11.775 4.8L2 14.575V16ZM0 18V13.75L13.2 0.575C13.4 0.391667 13.6208 0.25 13.8625 0.15C14.1042 0.05 14.3583 0 14.625 0C14.8917 0 15.15 0.05 15.4 0.15C15.65 0.25 15.8667 0.4 16.05 0.6L17.425 2C17.625 2.18333 17.7708 2.4 17.8625 2.65C17.9542 2.9 18 3.15 18 3.4C18 3.66667 17.9542 3.92083 17.8625 4.1625C17.7708 4.40417 17.625 4.625 17.425 4.825L4.25 18H0ZM12.475 5.525L11.775 4.8L13.2 6.225L12.475 5.525Z" fill="#ffffff" />
            </svg>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              hidden
            />
          </label>
        </div>
      </div>

      {/* Editable Grid */}
      <div className="info-gridd">
        <div className="info-boxx">
          <label>शिक्षकाचे नाव</label>
          <input
            value={form.teacherName}
            onChange={(e) =>
              setForm({ ...form, teacherName: e.target.value })
            }
          />

        </div>
        <div className="info-boxx">
          <label>ईमेल</label>
          <input
            type="email"
            value={form.email}
            onChange={(e) =>
              setForm({ ...form, email: e.target.value })
            }
          />
        </div>
        <div className="info-boxx">
          <label>मोबाईल नं.</label>
          <input
            value={form.phoneNumber}
            onChange={(e) =>
              setForm({ ...form, phoneNumber: e.target.value })
            }
          />
        </div>
        <div className="info-boxx">
          <label>इयत्ता नियुक्त करा	 </label>
          <select
            value={form.standardIds[0] || ""}
            onChange={(e) => handleSelectArray(e, "standardIds")}
          >

            <option value="">इयत्ता निवडा</option>

            {standards.map(s => (
              <option key={s.id} value={s.id}>
                {s.name}
              </option>
            ))}
          </select>

        </div>
        <div className="info-boxx">
          <label>परीक्षेचे नाव</label>
          <select
            value={form.softwareIds[0] || ""}
            onChange={(e) => handleSelectArray(e, "softwareIds")}
          >
            <option value="">परीक्षेचे नाव</option>

            {softwares.map(s => (
              <option key={s.id} value={s.id}>
                {s.name}
              </option>
            ))}
          </select>

        </div>
        <div className="info-boxx">
          <label>विषय नियुक्त करा	   </label>
          <select
            value={form.subjectIds[0] || ""}
            onChange={(e) => handleSelectArray(e, "subjectIds")}
          >
            <option value="">विषय निवडा</option>

            {subjects.map(sub => (
              <option key={sub.id} value={sub.id}>
                {sub.name}
              </option>
            ))}
          </select>

        </div>
      </div>
      {showPasswordPopup && (
        <div className="modal-overlay">
          <div className="password-modal">
            <div className="lock-icon"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 100 100" fill="none">
              <path d="M24.9993 91.6719C22.7077 91.6719 20.7459 90.8559 19.1139 89.224C17.482 87.592 16.666 85.6302 16.666 83.3385V41.6719C16.666 39.3802 17.482 37.4184 19.1139 35.7865C20.7459 34.1545 22.7077 33.3385 24.9993 33.3385H29.166V25.0052C29.166 19.2413 31.1973 14.3281 35.2598 10.2656C39.3223 6.20312 44.2355 4.17188 49.9993 4.17188C55.7632 4.17188 60.6764 6.20312 64.7389 10.2656C68.8014 14.3281 70.8327 19.2413 70.8327 25.0052V33.3385H74.9993C77.291 33.3385 79.2528 34.1545 80.8848 35.7865C82.5167 37.4184 83.3327 39.3802 83.3327 41.6719V83.3385C83.3327 85.6302 82.5167 87.592 80.8848 89.224C79.2528 90.8559 77.291 91.6719 74.9993 91.6719H24.9993ZM49.9993 70.8385C52.291 70.8385 54.2528 70.0226 55.8848 68.3906C57.5167 66.7587 58.3327 64.7969 58.3327 62.5052C58.3327 60.2135 57.5167 58.2517 55.8848 56.6198C54.2528 54.9878 52.291 54.1719 49.9993 54.1719C47.7077 54.1719 45.7459 54.9878 44.1139 56.6198C42.482 58.2517 41.666 60.2135 41.666 62.5052C41.666 64.7969 42.482 66.7587 44.1139 68.3906C45.7459 70.0226 47.7077 70.8385 49.9993 70.8385ZM37.4993 33.3385H62.4993V25.0052C62.4993 21.533 61.2841 18.5816 58.8535 16.151C56.423 13.7205 53.4716 12.5052 49.9993 12.5052C46.5271 12.5052 43.5757 13.7205 41.1452 16.151C38.7146 18.5816 37.4993 21.533 37.4993 25.0052V33.3385Z" fill="#2563EB" />
            </svg></div>

            <h3>पासवर्ड बदला</h3>
            <p className="modal-text">
              तुमचा पासवर्ड बदलण्यासाठी कृपया खालील माहिती भरा.तुमचा पासवर्ड किमान ८ अक्षरांचा असावा.त्यामध्ये किमान एक मोठं अक्षर, एक लहान अक्षर, एक संख्या, आणि एक विशेष चिन्ह (special character) असणे आवश्यक आहे.
            </p>

            <div className="modal-input">
              <label>सध्याचा पासवर्ड</label>

              <div className="password-wrapper">
                <input
                  type={showCurrent ? "text" : "password"}
                  placeholder="सध्याचा पासवर्ड"
                />

                <span onClick={() => setShowCurrent(!showCurrent)} className="eye-icon">
                  {showCurrent ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 5C7 5 3 9 2 12C3 15 7 19 12 19C17 19 21 15 22 12C21 9 17 5 12 5Z"
                        stroke="#616161"
                        strokeWidth="1.5"
                      />
                      <circle
                        cx="12"
                        cy="12"
                        r="3"
                        stroke="#616161"
                        strokeWidth="1.5"
                      />
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M15.4454 12.6473L14.6492 11.8511C14.7992 10.9781 14.5518 10.2223 13.9069 9.58381C13.2621 8.94531 12.5095 8.70106 11.6492 8.85106L10.8529 8.05481C11.0209 7.98565 11.1963 7.93373 11.3789 7.89906C11.5616 7.86456 11.7683 7.84731 11.9992 7.84731C13.0183 7.84731 13.8821 8.20148 14.5904 8.90981C15.2988 9.61815 15.6529 10.4819 15.6529 11.5011C15.6529 11.7319 15.6357 11.9451 15.6012 12.1406C15.5665 12.3361 15.5146 12.505 15.4454 12.6473ZM18.6069 15.7203L17.8492 15.0511C18.4825 14.5677 19.045 14.0386 19.5367 13.4636C20.0283 12.8886 20.4492 12.2344 20.7992 11.5011C19.9658 9.81773 18.77 8.48023 17.2117 7.48856C15.6533 6.4969 13.9158 6.00106 11.9992 6.00106C11.5158 6.00106 11.0408 6.0344 10.5742 6.10106C10.1075 6.16773 9.64917 6.26773 9.19917 6.40106L8.41842 5.62031C8.99926 5.40115 9.59025 5.24315 10.1914 5.14631C10.7928 5.04948 11.3953 5.00106 11.9992 5.00106C14.1697 5.00106 16.1549 5.59756 17.9549 6.79056C19.7549 7.9834 21.0773 9.55356 21.9222 11.5011C21.5645 12.3049 21.1117 13.0603 20.5637 13.7673C20.0155 14.4745 19.3633 15.1255 18.6069 15.7203ZM19.7222 21.1396L15.8299 17.2588C15.3876 17.455 14.8386 17.6277 14.1829 17.7771C13.5271 17.9264 12.7992 18.0011 11.9992 18.0011C9.81584 18.0011 7.83059 17.4046 6.04342 16.2116C4.25626 15.0187 2.93384 13.4486 2.07617 11.5011C2.46451 10.6177 2.97667 9.79048 3.61267 9.01931C4.24851 8.24815 4.92734 7.60106 5.64917 7.07806L2.86067 4.27806L3.56842 3.57031L20.4299 20.4318L19.7222 21.1396ZM6.35692 7.78556C5.78376 8.1934 5.19784 8.72931 4.59917 9.39331C4.00051 10.0575 3.53384 10.7601 3.19917 11.5011C4.03251 13.1844 5.22834 14.5219 6.78667 15.5136C8.34501 16.5052 10.0825 17.0011 11.9992 17.0011C12.5762 17.0011 13.1576 16.945 13.7434 16.8328C14.3293 16.7206 14.7697 16.6075 15.0647 16.4933L13.4337 14.8511C13.276 14.9396 13.0562 15.0123 12.7742 15.0693C12.4922 15.1263 12.2338 15.1548 11.9992 15.1548C10.98 15.1548 10.1163 14.8006 9.40792 14.0923C8.69959 13.384 8.34542 12.5202 8.34542 11.5011C8.34542 11.2792 8.37392 11.0305 8.43092 10.7548C8.48792 10.4793 8.56067 10.2499 8.64917 10.0666L6.35692 7.78556Z" fill="#616161" />
                    </svg>
                  )}
                </span>

              </div>
            </div>

            <div className="modal-input">
              <label>नवीन पासवर्ड</label>

              <div className="password-wrapper">
                <input
                  type={showNew ? "text" : "password"}
                  placeholder="नवीन पासवर्ड"
                />

                <span onClick={() => setShowNew(!showNew)} className="eye-icon">
                  {showNew ? (
                    /* 👁 OPEN EYE */
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 5C7 5 3 9 2 12C3 15 7 19 12 19C17 19 21 15 22 12C21 9 17 5 12 5Z"
                        stroke="#616161"
                        strokeWidth="1.5"
                      />
                      <circle
                        cx="12"
                        cy="12"
                        r="3"
                        stroke="#616161"
                        strokeWidth="1.5"
                      />
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M15.4454 12.6473L14.6492 11.8511C14.7992 10.9781 14.5518 10.2223 13.9069 9.58381C13.2621 8.94531 12.5095 8.70106 11.6492 8.85106L10.8529 8.05481C11.0209 7.98565 11.1963 7.93373 11.3789 7.89906C11.5616 7.86456 11.7683 7.84731 11.9992 7.84731C13.0183 7.84731 13.8821 8.20148 14.5904 8.90981C15.2988 9.61815 15.6529 10.4819 15.6529 11.5011C15.6529 11.7319 15.6357 11.9451 15.6012 12.1406C15.5665 12.3361 15.5146 12.505 15.4454 12.6473ZM18.6069 15.7203L17.8492 15.0511C18.4825 14.5677 19.045 14.0386 19.5367 13.4636C20.0283 12.8886 20.4492 12.2344 20.7992 11.5011C19.9658 9.81773 18.77 8.48023 17.2117 7.48856C15.6533 6.4969 13.9158 6.00106 11.9992 6.00106C11.5158 6.00106 11.0408 6.0344 10.5742 6.10106C10.1075 6.16773 9.64917 6.26773 9.19917 6.40106L8.41842 5.62031C8.99926 5.40115 9.59025 5.24315 10.1914 5.14631C10.7928 5.04948 11.3953 5.00106 11.9992 5.00106C14.1697 5.00106 16.1549 5.59756 17.9549 6.79056C19.7549 7.9834 21.0773 9.55356 21.9222 11.5011C21.5645 12.3049 21.1117 13.0603 20.5637 13.7673C20.0155 14.4745 19.3633 15.1255 18.6069 15.7203ZM19.7222 21.1396L15.8299 17.2588C15.3876 17.455 14.8386 17.6277 14.1829 17.7771C13.5271 17.9264 12.7992 18.0011 11.9992 18.0011C9.81584 18.0011 7.83059 17.4046 6.04342 16.2116C4.25626 15.0187 2.93384 13.4486 2.07617 11.5011C2.46451 10.6177 2.97667 9.79048 3.61267 9.01931C4.24851 8.24815 4.92734 7.60106 5.64917 7.07806L2.86067 4.27806L3.56842 3.57031L20.4299 20.4318L19.7222 21.1396ZM6.35692 7.78556C5.78376 8.1934 5.19784 8.72931 4.59917 9.39331C4.00051 10.0575 3.53384 10.7601 3.19917 11.5011C4.03251 13.1844 5.22834 14.5219 6.78667 15.5136C8.34501 16.5052 10.0825 17.0011 11.9992 17.0011C12.5762 17.0011 13.1576 16.945 13.7434 16.8328C14.3293 16.7206 14.7697 16.6075 15.0647 16.4933L13.4337 14.8511C13.276 14.9396 13.0562 15.0123 12.7742 15.0693C12.4922 15.1263 12.2338 15.1548 11.9992 15.1548C10.98 15.1548 10.1163 14.8006 9.40792 14.0923C8.69959 13.384 8.34542 12.5202 8.34542 11.5011C8.34542 11.2792 8.37392 11.0305 8.43092 10.7548C8.48792 10.4793 8.56067 10.2499 8.64917 10.0666L6.35692 7.78556Z" fill="#616161" />
                    </svg>
                  )}
                </span>
              </div>
            </div>

            <div className="modal-input">
              <label>पासवर्ड पुन्हा लिहा</label>

              <div className="password-wrapper">
                <input
                  type={showConfirm ? "text" : "password"}
                  placeholder="पासवर्ड पुन्हा लिहा"
                />

                <span onClick={() => setShowConfirm(!showConfirm)} className="eye-icon">
                  {showConfirm ? (
                    /* 👁 OPEN EYE */
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 5C7 5 3 9 2 12C3 15 7 19 12 19C17 19 21 15 22 12C21 9 17 5 12 5Z"
                        stroke="#616161"
                        strokeWidth="1.5"
                      />
                      <circle
                        cx="12"
                        cy="12"
                        r="3"
                        stroke="#616161"
                        strokeWidth="1.5"
                      />
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M15.4454 12.6473L14.6492 11.8511C14.7992 10.9781 14.5518 10.2223 13.9069 9.58381C13.2621 8.94531 12.5095 8.70106 11.6492 8.85106L10.8529 8.05481C11.0209 7.98565 11.1963 7.93373 11.3789 7.89906C11.5616 7.86456 11.7683 7.84731 11.9992 7.84731C13.0183 7.84731 13.8821 8.20148 14.5904 8.90981C15.2988 9.61815 15.6529 10.4819 15.6529 11.5011C15.6529 11.7319 15.6357 11.9451 15.6012 12.1406C15.5665 12.3361 15.5146 12.505 15.4454 12.6473ZM18.6069 15.7203L17.8492 15.0511C18.4825 14.5677 19.045 14.0386 19.5367 13.4636C20.0283 12.8886 20.4492 12.2344 20.7992 11.5011C19.9658 9.81773 18.77 8.48023 17.2117 7.48856C15.6533 6.4969 13.9158 6.00106 11.9992 6.00106C11.5158 6.00106 11.0408 6.0344 10.5742 6.10106C10.1075 6.16773 9.64917 6.26773 9.19917 6.40106L8.41842 5.62031C8.99926 5.40115 9.59025 5.24315 10.1914 5.14631C10.7928 5.04948 11.3953 5.00106 11.9992 5.00106C14.1697 5.00106 16.1549 5.59756 17.9549 6.79056C19.7549 7.9834 21.0773 9.55356 21.9222 11.5011C21.5645 12.3049 21.1117 13.0603 20.5637 13.7673C20.0155 14.4745 19.3633 15.1255 18.6069 15.7203ZM19.7222 21.1396L15.8299 17.2588C15.3876 17.455 14.8386 17.6277 14.1829 17.7771C13.5271 17.9264 12.7992 18.0011 11.9992 18.0011C9.81584 18.0011 7.83059 17.4046 6.04342 16.2116C4.25626 15.0187 2.93384 13.4486 2.07617 11.5011C2.46451 10.6177 2.97667 9.79048 3.61267 9.01931C4.24851 8.24815 4.92734 7.60106 5.64917 7.07806L2.86067 4.27806L3.56842 3.57031L20.4299 20.4318L19.7222 21.1396ZM6.35692 7.78556C5.78376 8.1934 5.19784 8.72931 4.59917 9.39331C4.00051 10.0575 3.53384 10.7601 3.19917 11.5011C4.03251 13.1844 5.22834 14.5219 6.78667 15.5136C8.34501 16.5052 10.0825 17.0011 11.9992 17.0011C12.5762 17.0011 13.1576 16.945 13.7434 16.8328C14.3293 16.7206 14.7697 16.6075 15.0647 16.4933L13.4337 14.8511C13.276 14.9396 13.0562 15.0123 12.7742 15.0693C12.4922 15.1263 12.2338 15.1548 11.9992 15.1548C10.98 15.1548 10.1163 14.8006 9.40792 14.0923C8.69959 13.384 8.34542 12.5202 8.34542 11.5011C8.34542 11.2792 8.37392 11.0305 8.43092 10.7548C8.48792 10.4793 8.56067 10.2499 8.64917 10.0666L6.35692 7.78556Z" fill="#616161" />
                    </svg>
                  )}
                </span>
              </div>
            </div>


            <button
              className="modal-btn"
              onClick={() => {
                setShowPasswordPopup(false); // password modal close
                setShowSuccessPopup(true);   // success popup open
              }}
            >
              पासवर्ड बदला
            </button>


            <span
              className="modal-close"
              onClick={() => setShowPasswordPopup(false)}
            >
              ✕
            </span>
          </div>
        </div>
      )}
      {showSuccessPopup && (
        <div className="modal-overlay">
          <div className="success-modal">
            <div className="success-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" fill="#2563EB" />
                <path
                  d="M8 12.5L10.5 15L16 9"
                  stroke="#fff"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <h3>पासवर्ड यशस्वीरीत्या अद्ययावत झाला!</h3>

            <p className="success-text">
              आपला नवीन पासवर्ड सुरक्षितरित्या जतन केला गेला आहे. <br />
              कृपया पुढील वापरासाठी तो लक्षात ठेवा.
            </p>

            <button
              className="success-btn"
              onClick={() => setShowSuccessPopup(false)}
            >
              ठीक आहे
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TeacherEdit;
